import React, { Component } from 'react';
import NoticeUi from '../../../presentationals/Admin/Recovery/Notice.component';
import { APIS } from '../../../../utils/api-factory'

class NoticeDelivered extends Component {
    constructor(props) {
        super(props);
        this.state = {
            noticeData: '',
            FilteredData: [],
            pageIndexToShow: 0,
        }
    }

    componentWillMount() {
        fetch(APIS.GET_NOTICE_DATA + 1 + '&type=emi')
            .then(res => res.json())
            .then(json => {
                this.setState({ noticeData: json })
            })
    }

    render() {
        return (
            <div className="full-height">
                <NoticeUi
                    noticeData={this.state.noticeData}
                    getFilterValue={this.getFilterValue.bind(this)}
                    FilteredData={this.state.FilteredData}
                    getPageValue={this.getPageValue.bind(this)}
                    pageIndexToShow={this.state.pageIndexToShow} />
            </div>
        )
    }

    getFilterValue(filtered) {
        this.setState({ FilteredData: filtered })
    }

    getPageValue(pageIndex) {
        this.setState({ pageIndexToShow: pageIndex })
    }

}

export default NoticeDelivered;